import { defineStyleConfig as e } from "@chakra-ui/react";
const o = e({
  baseStyle: {
    color: "teal.500"
  },
  sizes: {
    sm: {
      h: "14px",
      w: "14px"
    },
    md: {
      h: "16px",
      w: "16px"
    },
    lg: {
      h: "18px",
      w: "18px"
    }
  },
  defaultProps: {
    size: "md"
  }
});
export {
  o as default
};
